import * as React from 'react'
import useScript from './useScript'

interface GoogleLogoutProps {
  email: string
  onGoogleSignOut: () => void
  render: (props: { onClick?: () => void }) => JSX.Element
}

/**
 * https://developers.google.com/identity/gsi/web/reference/js-reference#google.accounts.id.revoke
 */
const GoogleLogout = (props: GoogleLogoutProps) => {
  const { email, onGoogleSignOut, render } = props

  const [isLoading, setIsLoading] = React.useState(true)

  const revoke = React.useCallback(() => {
    google.accounts.id.revoke(email, onGoogleSignOut)
  }, [isLoading])

  useScript('https://accounts.google.com/gsi/client', () => {
    google.accounts.id.initialize({
      client_id: '672780895951-cu4kv06fbt03vhi9f5gms308kmdj9s7i.apps.googleusercontent.com',
    })
    setIsLoading(false)
  })

  return render({ onClick: revoke })
}

export default GoogleLogout
